import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MarketingLayoutBodyComponent } from './layout/marketing-layout/marketing-layout-body/marketing-layout-body.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { authGuard } from './guards/auth.guard';
import { PublicLayoutBodyComponent } from './layout/public-layout/public-layout-body/public-layout-body.component';
import { superAdminGuard } from './guards/super-admin.guard';
import { ngoAdminGuard } from './guards/ngo-admin.guard';
import { corporateEmployeeGuard } from './guards/employee-admin.guard';
import { LoggedInMenuComponent } from './layout/logged-in-layout/logged-in-menu/logged-in-menu.component';
import { opsAdminGuard } from './guards/ops-admin.guard';
import { corporateGuard } from './guards/corporate.guard';

const routes: Routes = [
  { path: 'home', redirectTo: '', pathMatch: 'full' },
  {
    path: 'public',
    component: PublicLayoutBodyComponent,
    loadChildren: () =>
      import('./modules/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    component: LoggedInMenuComponent,
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [authGuard, ngoAdminGuard],
  },
  {
    path: 'admin',
    component: LoggedInMenuComponent,
    loadChildren: () =>
      import('./modules/super-admin/super-admin.module').then(
        (m) => m.SuperAdminModule
      ),
    canActivate: [authGuard, superAdminGuard],
  },
  {
    path: 'corporate',
    component: LoggedInMenuComponent,
    loadChildren: () =>
      import('./modules/corporate/corporate.module').then(
        (m) => m.CorporateModule
      ),
    canActivate: [authGuard, corporateGuard],
  },
  {
    path: 'employee',
    component: LoggedInMenuComponent,
    loadChildren: () =>
      import('./modules/employee/employee.module').then(
        (m) => m.EmployeeModule
      ),
    canActivate: [authGuard, corporateEmployeeGuard],
  },
  {
    path: 'ops-admin',
    component: LoggedInMenuComponent,
    loadChildren: () =>
      import('./modules/ops-admin/ops-admin.module').then(
        (m) => m.OpsAdminModule
      ),
    canActivate: [authGuard, opsAdminGuard],
  },
  {
    path: '',
    component: MarketingLayoutBodyComponent,
    loadChildren: () =>
      import('./modules/marketing/marketing.module').then(
        (m) => m.MarketingModule
      ),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
